export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6190.26e2b893.jpg";